<style lang="less">
    .ai-drops {
        .menu-item:not(:last-child) {
            margin-bottom: 4px;
        }
    }
</style>
<template>
    <MenuList
        class="ai-drops"
        :menuList="menuList"
        @handleClicks="handleClicks(...arguments)"
        @handleMouseenter="handleMouseenter(...arguments)"
        :showTippy="false"
    ></MenuList>
</template>

<script lang="ts">
    import { Component, Watch, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AIDrop extends Vue {
        activeKey = "";

        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }

        @Watch("showDropdown")
        changeLayerOpertaion(val) {
            if (!val) {
                this.activeKey = "";
            }
        }

        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get isChart() {
            return this.$store.state.shape.type == "EDChart";
        }
        get isGantt() {
            return this.$store.state.shape.type == "Gantt";
        }
        get isTable() {
            return this.$store.state.shape.type == "Table";
        }
        get isOrg() {
            return this.$store.state.shape.type == "OrgShape";
        }
        get flowAnalyse() {
            return this.$store.state.shape.flowAnalyse;
        }
        get menuList() {
            let list = [
                { key: "talk" },
                window.EDCONFIG.AI.DRAW_ENABLE ? { key: "paint" } : undefined,
                { divide: true },
                {
                    key: "diagram",
                    label: this.$t("diagram"),
                    isTitle: true,
                    disabled: true,
                },
                { key: "flowchart" },
                { key: "mindmap" },
                { key: "timeline" },
                { key: "swot" },
                { divide: true },
                {
                    key: "aiAnalysis",
                    label: this.$t("aiAnalysis"),
                    isTitle: true,
                    disabled: true,
                },
                !this.internal
                    ? {
                          key: "pictureAnalysis",
                      }
                    : undefined,
                {
                    key: "documentAnalysis",
                },
                {
                    key: "textAnalysis",
                },
                // {
                //     key: "flow_analysis",
                //     expand: true,
                //     disabled: !this.isSelect || !this.flowAnalyse,

                // },
                // {
                //     key: "chart_analysis",
                //     expand: true,
                //     disabled: !this.isSelect || !this.isChart,

                // },
                // {
                //     key: "gantt_analysis",
                //     expand: true,
                //     disabled: !this.isSelect || !this.isGantt,

                // },
                // {
                //     key: "table_analysis",
                //     expand: true,
                //     disabled: !this.isSelect || !this.isTable,

                // },
                // {
                //     key: "orgchart_analysis",
                //     expand: true,
                //     disabled: !this.isSelect || !this.isOrg,

                // },
                { divide: true },
                {
                    key: "chart",
                    label: this.$t("chart"),
                    isTitle: true,
                    disabled: true,
                },
                {
                    key: "line",
                },
                {
                    key: "bar",
                },
                {
                    key: "pie",
                },
                { divide: true },
                { key: "AIMore", expand: true, active: false },

                // { key: "chatGPT", img: require("@/app/assets/img/ai/ai-chat.svg") },
                // { key: "OCR", img: require("@/app/assets/img/ai/OCR.svg"), disabled: false },
            ].filter(Boolean);
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });

            let resultList = [];
            list.map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });

            if (window.EDCONFIG.IS_SDK) {
                resultList = resultList.filter((v) => v.key !== "mindmap" && v.key !== "timeline");
            }

            return { container: "AI-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            // prettier-ignore
            const toAiImg = (type) => {
                this.$bus.$emit("showAIPanel", true);
                this.$nextTick(() => {
                    this.$bus.$emit("aiClickImglist", type)
                })
            }
            const toAiAnalyse = (id, ustr) => {
                this.$bus.$emit("showAIPanel", true);
                this.$nextTick(() => {
                    this.$bus.$emit("aiAnalyse", id, ustr);
                });
            };
            const trackClick = (type) => {
                this.sensors.track("clickAItoolbar", {
                    Catalogues: "AI",
                    click_type: type,
                });
            };
            let clickEvents = new Map([
                [
                    "talk",
                    () => {
                        event.stopPropagation();
                        this.$bus.$emit("showAIPanel", true);
                        this.$nextTick(() => {
                            this.$bus.$emit("aiChat");
                        });
                        // this.showAiChat();
                        this.sensors.track("openAI", {
                            Catalogues: "AI",
                            open_way: "from_entrance",
                        });
                        trackClick("AI Chat");
                    },
                ],
                [
                    "paint",
                    () => {
                        event.stopPropagation();
                        this.showDialog("AIDraw");
                        trackClick("AI Drawing");
                    },
                ],
                [
                    "flowchart",
                    () => {
                        toAiImg("flowchart");
                        trackClick("Flowchart");
                    },
                ],
                [
                    "mindmap",
                    () => {
                        toAiImg("mindmap");
                        trackClick("Mind Map");
                    },
                ],
                [
                    "timeline",
                    () => {
                        toAiImg("timeline");
                        trackClick("Timeline");
                    },
                ],
                [
                    "swot",
                    () => {
                        toAiImg("swot");
                        trackClick("SWOT Analysis");
                    },
                ],
                [
                    "pictureAnalysis",
                    () => {
                        toAiImg(key);
                    },
                ],
                [
                    "documentAnalysis",
                    () => {
                        toAiImg(key);
                    },
                ],
                [
                    "textAnalysis",
                    () => {
                        toAiImg(key);
                    },
                ],
                [
                    "line",
                    () => {
                        toAiImg(key);
                    },
                ],
                [
                    "bar",
                    () => {
                        toAiImg(key);
                    },
                ],
                [
                    "pie",
                    () => {
                        toAiImg(key);
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
            this.closeMenu();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = key;
            this.showExpand(event, key);
        }
        showExpand(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["AIMore", "flow_analysis", "chart_analysis", "gantt_analysis", "table_analysis", "orgchart_analysis"].includes(type)) {
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: true,
                });
            }
        }
        showAiChat() {
            this.closeMenu();
            this.sensors.track("openAISmartAssistant", {
                Catalogues: "AI",
                open_way: "from_entrance",
            });
            this.$store.commit("setStatus", {
                type: "showAIBotDialog",
                data: true,
            });
            // this.showDialog("AiChatModal");
        }
        showOCRDialog() {
            // 打开文字识别弹窗
            this.closeMenu();
            this.showDialog("OCRModal");

            this.sensors.track("clickOcr", {
                Catalogues: "AI",
            });
        }
        closeMenu() {
            // 关闭下拉菜单
            this.$emit("closeDrop");
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }

        get isActiveShape() {
            return this.$store.state.shape.isActived;
        }
        get isGrouped() {
            return this.$store.state.shape.isGrouped;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }

        mounted() {}

        created() {}
        deactivated() {
            this.activeKey = "";
        }
    }
</script>
<i18n>
{
  "zh": {
    "diagram": "AI 制图",
    "chart": "AI 图表",
    "aiAnalysis": "AI 分析",
    "pictureAnalysis": "图片分析",
    "documentAnalysis": "文件分析",
    "textAnalysis": "文本分析",
    "line": "折线图",
    "bar": "柱状图",
    "pie": "饼图",
    "chatGPT": "AI智能助手",
    "talk": "AI 对话",
    "paint": "AI 绘画",
    "flowchart": "流程图",
    "mindmap": "思维导图",
    "timeline": "时间线",
    "swot": "SWOT分析",
    "flow_analysis": "流程图分析",
    "chart_analysis": "图表分析",
    "gantt_analysis": "甘特图分析",
    "AIMore": "探索更多AI功能",
    "table_analysis": "表格分析",
    "orgchart_analysis": "组织结构图分析",
    "OCR": "OCR图片文字提取",
    "": "",
    "": "",
    "": ""
  },
  "en": {
    "diagram": "AI Diagram",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Picture Analysis",
    "documentAnalysis": "Document Analysis",
    "textAnalysis": "Text Analysis",
    "chart": "AI Chart",
    "line": "Line Chart",
    "bar": "Bar Chart",
    "pie": "Pie Chart",
    "chatGPT": "AI Assistant",
    "talk": "AI Chat",
    "paint": "AI Drawing",
    "flowchart": "Flowchart",
    "mindmap": "Mind Map",
    "timeline": "Timeline",
    "swot": "SWOT Analysis",
    "flow_analysis": "Flowchart Analysis",
    "chart_analysis": "Chart Analysis",
    "gantt_analysis": "Gantt Chart Analysis",
    "AIMore": "Discover more AI features",
    "table_analysis": "Table Analysis",
    "orgchart_analysis": "Organizational Chart Analysis",
    "OCR": "OCR Image Text Extraction"
  },
  "fr": {
    "diagram": "Diagramme IA",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Analyse d'image",
        "documentAnalysis": "Analyse de documents",
        "textAnalysis": "Analyse de texte",
        "chart": "Graphique IA",
        "line": "Graphiques en courbes",
        "bar": "Graphiques à barres",
        "pie": "Graphiques en secteurs",
    "chatGPT": "AI Assistant",
    "talk": "Chat AI",
    "paint": "Dessin AI",
    "flowchart": "Organigramme",
    "mindmap": "Carte mentale",
    "timeline": "Chronologie",
    "swot": "Analyse SWOT",
    "flow_analysis": "Analyse d'organigramme",
    "chart_analysis": "Analyse de graphique",
    "gantt_analysis": "Analyse de diagramme de Gantt",
    "AIMore": "Découvrir plus de fonctionnalités IA",
    "table_analysis": "Analyse de tableau",
    "orgchart_analysis": "Analyse d'organigramme hiérarchique",
    "OCR": "Extraction de texte d'image via OCR"
  },
  "de": {
    "diagram": "KI-Diagramm",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Bildanalyse",
        "documentAnalysis": "Dokumentanalyse",
        "textAnalysis": "Textanalyse",
        "chart": "KI-Diagramm", "line": "Liniendiagramme",
        "bar": "Balkendiagramme",
        "pie": "Kreisdiagramme",
    "chatGPT": "AI Assistant",
    "talk": "AI Chat",
    "paint": "AI Drawing",
    "flowchart": "Flussdiagramm",
    "mindmap": "Mindmap",
    "timeline": "Zeitachse",
    "swot": "SWOT-Analyse",
    "flow_analysis": "Flussdiagramm-Analyse",
    "chart_analysis": "Diagrammanalyse",
    "gantt_analysis": "Gantt-Diagrammanalyse",
    "AIMore": "Weitere KI-Funktionen entdecken",
    "table_analysis": "Tabellenanalyse",
    "orgchart_analysis": "Organigramm-Analyse",
    "OCR": "OCR Bild-Text-Extraktion"
  },
  "jp": {
    "diagram": "AI ダイアグラム",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "画像解析",
        "documentAnalysis": "ドキュメント解析",
        "textAnalysis": "テキスト分析",
        "chart": "AI チャート",
        "line": "折れ線グラフ",
        "bar": "棒グラフ",
        "pie": "円グラフ",
    "chatGPT": "AI Assistant",
    "talk": "AIチャット",
    "paint": "AI描画",
    "flowchart": "フローチャート",
    "mindmap": "マインドマップ",
    "timeline": "タイムライン",
    "swot": "SWOT分析",
    "flow_analysis": "フローチャートの分析",
    "chart_analysis": "チャート分析",
    "gantt_analysis": "ガントチャート分析",
    "AIMore": "AI機能の詳細を表示",
    "table_analysis": "テーブル分析",
    "orgchart_analysis": "組織図分析",
    "OCR": "OCR画像テキスト抽出"
  },
  "es": {
    "diagram": "Diagrama de IA",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Análisis de imágenes",
        "documentAnalysis": "Análisis de documentos",
        "textAnalysis": "Análisis de texto",
        "chart": "Gráfico IA",
        "line": "Gráficos de líneas",
        "bar": "Gráficos de barras",
        "pie": "Gráficos circulares",
    "chatGPT": "AI Assistant",
    "talk": "Chat de AI",
    "paint": "Dibujo de AI",
    "flowchart": "Diagrama de flujo",
    "mindmap": "Mapa mental",
    "timeline": "Línea de tiempo",
    "swot": "Análisis DAFO",
    "flow_analysis": "Análisis de diagrama de flujo",
    "chart_analysis": "Análisis de diagrama",
    "gantt_analysis": "Análisis de diagrama de Gantt",
    "AIMore": "Descubrir más funciones de IA",
    "table_analysis": "Análisis de tabla",
    "orgchart_analysis": "Análisis de organigrama",
    "OCR": "Extracción de texto de imágenes con OCR"
  },
  "pt": {
    "diagram": "Diagrama de IA",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Análise de imagem",
        "documentAnalysis": "Análise de documento",
        "textAnalysis": "Análise de texto",
        "chart": "Gráfico de IA",
        "line": "Gráficos de linha",
        "bar": "Gráfico de barras",
        "pie": "Gráficos de pizza",
    "chatGPT": "AI Assistant",
    "talk": "Chat por IA",
    "paint": "Desenho por IA",
    "flowchart": "Fluxograma",
    "mindmap": "Mapa mental",
    "timeline": "Linha do tempo",
    "swot": "Análise SWOT",
    "flow_analysis": "Análise de fluxograma",
    "chart_analysis": "Análise de gráficos",
    "gantt_analysis": "Análise do gráfico de Gantt",
    "AIMore": "Descubra mais recursos de IA",
    "table_analysis": "Análise de tabela",
    "orgchart_analysis": "Análise de organograma",
    "OCR": "Extração de texto de imagem por OCR"
  },
  "id": {
    "talk": "Obrolan AI",
    "paint": "Gambar AI",
    "flowchart": "Bagan Alur",
    "mindmap": "Peta Pikiran",
    "timeline": "Garis Waktu",
    "swot": "Analisis SWOT",
    "flow_analysis": "流程图分析",
    "chart_analysis": "Analisis Bagan",
    "gantt_analysis": "Analisis Bagan Gantt",
    "AIMore": "Alat Pintar",
    "table_analysis": "Analisis Tabel",
    "orgchart_analysis": "Analisis Bagan Organisasi",
    "OCR": "Ekstraksi Teks Gambar OCR"
  },
  "it": {
    "diagram": "Diagramma IA",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "Analisi immagine",
        "documentAnalysis": "Analisi documento",
        "textAnalysis": "Analisi testo",
        "chart": "Grafico IA",
        "line": "Grafici a linee",
        "bar": "Grafici a barre",
        "pie": "Grafici a torta",
    "chatGPT": "AI Assistant",
    "talk": "Obrolan AI",
    "paint": "Disegno AI",
    "flowchart": "Diagramma di flusso",
    "mindmap": "Mappa mentale",
    "timeline": "Cronologia",
    "swot": "Analisi SWOT",
    "flow_analysis": "Analisi diagramma di flusso",
    "chart_analysis": "Analisi grafico",
    "gantt_analysis": "Analisi diagramma di Gantt",
    "AIMore": "Scopri altre funzioni AI",
    "table_analysis": "Analisi tabella",
    "orgchart_analysis": "Analisi organigramma",
    "OCR": "Estrazione del testo da immagine OCR"
  },
  "tw": {
    "diagram": "AI 圖表",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "圖片分析",
        "documentAnalysis": "文件分析",
        "textAnalysis": "文字分析",
        "chart": "AI 圖表",
        "line": "折線圖",
        "bar": "長條圖",
        "pie": "圓形圖",
    "chatGPT": "AI Assistant",
    "talk": "AI 聊天",
    "paint": "AI 繪圖",
    "flowchart": "流程圖",
    "mindmap": "心智圖",
    "timeline": "時間軸",
    "swot": "SWOT 分析",
    "flow_analysis": "流程圖分析",
    "chart_analysis": "圖表分析",
    "gantt_analysis": "甘特圖分析",
    "AIMore": "探索更多 AI 功能",
    "table_analysis": "表格分析",
    "orgchart_analysis": "組織圖分析",
    "OCR": "OCR 影像文字擷取"
  },
  "kr": {
    "diagram": "AI 다이어그램",
    "aiAnalysis": "AI Analysis",
    "pictureAnalysis": "사진 분석",
        "documentAnalysis": "문서 분석",
        "textAnalysis": "텍스트 분석",
        "chart": "AI 차트",
        "line": "선형 차트",
        "bar": "막대 차트",
        "pie": "원형 차트",
    "chatGPT": "AI Assistant",
    "talk": "AI 채팅",
    "paint": "AI 드로잉",
    "flowchart": "순서도",
    "mindmap": "마인드맵",
    "timeline": "타임라인",
    "swot": "SWOT 분석",
    "flow_analysis": "순서도 분석",
    "chart_analysis": "차트 분석",
    "gantt_analysis": "간트 차트 분석",
    "AIMore": "스마트 도구",
    "table_analysis": "표 분석",
    "orgchart_analysis": "조직도 분석",
    "OCR": "OCR 이미지 텍스트 추출"
  }
}
</i18n>
